import { Link } from 'react-router-dom';

import { PLANS, type PlanTier } from '@dca/shared';

import { Empty } from '../components/Ui.tsx';
import { UpgradeRequiredError } from '../lib/api.ts';

/**
 * A 402 from the API is a sales moment, not an error state. Any page can hand
 * its load error here and get the right prompt back, or null if the failure was
 * something else.
 */
export function UpgradePrompt({ error }: { error: unknown }) {
  if (!(error instanceof UpgradeRequiredError)) return null;
  const plan = PLANS[error.requiredTier as PlanTier] ?? PLANS.wood;

  return (
    <Empty title={`${plan.name} unlocks this`}>
      <p className="muted">{plan.blurb}</p>
      <Link to="/billing">
        <button className="primary">See plans</button>
      </Link>
    </Empty>
  );
}

export function ErrorState({ error }: { error: unknown }) {
  if (error instanceof UpgradeRequiredError) return <UpgradePrompt error={error} />;
  return (
    <Empty title="Could not load this view">
      <span className="muted">{error instanceof Error ? error.message : 'Unknown error'}</span>
    </Empty>
  );
}
